var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _vm.isSmartphone
          ? _c("page-nav-bar", {
              attrs: {
                currentServiceName: "MoneyRoad",
                subNavTitle: "Import CSV File",
                ReturnButton: true,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-10 offset-md-1" }, [
              _c("div", { staticClass: "panel21 panel-default" }, [
                _c(
                  "h4",
                  { staticClass: "content-block labelAccordionForm" },
                  [
                    _c("f7-icon", { attrs: { f7: "list_bullet" } }),
                    _vm._v("\n                    Import Direct Payments "),
                    _vm.importType === "draft"
                      ? _c("span", [_vm._v("(In Progress)")])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form",
                  [
                    _c("div", { staticClass: "form-group row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-5 col-sm-2",
                          class: _vm.colorBottomButton,
                        },
                        [
                          _c("div", { staticClass: "fileContainer" }, [
                            _vm._v(
                              "\n                    Choose file\n                    "
                            ),
                            _c("input", {
                              ref: "fileInput",
                              attrs: {
                                type: "file",
                                name: "file2",
                                id: "file2",
                              },
                              on: { change: _vm.onFileChange },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-7 col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fileName,
                              expression: "fileName",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            name: "filename",
                            placeholder: "Choose file",
                            type: "text",
                            disabled: "",
                          },
                          domProps: { value: _vm.fileName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.fileName = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.importType === "draft" && _vm.accountType === "1"
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-form-select", {
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "sel1",
                                    readonly: "",
                                    options: _vm.teamOptions,
                                  },
                                  model: {
                                    value: _vm.id_team,
                                    callback: function ($$v) {
                                      _vm.id_team = $$v
                                    },
                                    expression: "id_team",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-md-2 offset-md-9",
                class: _vm.colorBottomButton,
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "importAttachmentButton button-action firstButtonMarginTop",
                    attrs: { round: "" },
                    on: { click: _vm.importFile },
                  },
                  [
                    _c("f7-icon", { attrs: { f7: "list_bullet" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Import")]),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }